export const level1Data = {
  catImage: '/images/cats/starmeows.png',
  backgroundImage: '/images/backgrounds/level1.JPG',
  nextLevel: '/level2',
   catPosition: {
    x: '25%', 
    y: '63%'  
  },
};

export default level1Data;